<template>
  <div class="chart chart-move" style="height:auto;">
    <!-- <v-layout v-if="editMode" class="chart-tool">
      <v-flex row>
        <v-spacer/>
        <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>

    <v-layout>
      <v-flex
        class="text-sm-left"
        ml-1
        mb-2
        mt-3>
          {{chartName}}
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex row wrap mt-3 offset-md1 offset-lg1 lg2 md2 class="text-xs-right">
        <!-- XLS -->
        <v-flex offset-lg1 lg7 sm8 md6 xl8 >
          <json-excel
            :data="exportxls"
            type="xls"
            :title = "title"
            :name="chartName+'.xls'"
          >
            <v-btn dark flat icon style="outline: none;">
              <img :src="xls" style="width: 24px" />
            </v-btn>
          </json-excel>
        </v-flex>
        <!-- CSV -->
        <v-flex lg3 sm3 md6 xl2>
          <json-excel
            :data="exportxls"
            type="csv"
            :title = "title"
            :name="chartName+'.csv'"
          >
            <v-btn dark flat icon style="outline: none;">
              <img :src="csv" style="width: 24px" />
            </v-btn>
          </json-excel>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-3 ml-3>
      <v-flex lg3 md3>
        <v-select v-model="selectedHeaders" :items="options" label="Fields"
          hint="Choose the fields you want"
          persistent-hint
          multiple
          chips
          dark/>
      </v-flex>
      <v-flex lg2 offset-lg6 md2 offset-md6 mt-3>
        <v-select v-model="perPage" :items="perPageOptions" label="Items per page" dark/>
      </v-flex>
    </v-layout>
    <!-- TODO: Change to Vuetify Data table (It's useful now, I think) - Kittitad -->
    <div v-if="tableItems && tableItems.length">
      <!-- TABLE Start Here -->
      <b-table :fields="tableHeaders" :items="tableItems"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :current-page="currentPage"
        :per-page="perPage"
        :responsive="true"
        :hover="true"
        dark>
        <template slot="rawData" slot-scope="row">
          <v-btn small @click.stop="row.toggleDetails" class="mr-2">
            {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
          </v-btn>
        </template>
        <template slot="row-details" slot-scope="row">
          <v-card dark>
            <v-layout row class="mb-2" align-center justify-space-around>
              <v-flex lg11 md11 mt-4>{{ row.item._raw }}</v-flex>
            </v-layout>
            <v-flex class="mb-2">
            </v-flex>
            <v-btn small @click="row.toggleDetails">Hide Details</v-btn>
          </v-card>
        </template>
      </b-table>
      <b-pagination size="md" align="center" :total-rows="150" v-model="currentPage" :per-page="perPage"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ResizeSensor from 'css-element-queries/src/ResizeSensor'
import JsonExcel from 'vue-json-excel'
import csv from '../assets/img/csv.png'
import xls from '../assets/img/xls.png'

export default {
  name: 'x-table',
  components: {
    JsonExcel
  },
  props: {
    user_index: String,
    user_inst: String,
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '95%'
    },
    startTime: [String, Number],
    endTime: [String, Number],
    chartName: {
      type: String,
      default: 'Untitled'
    },
    chartId: String,
    options: Array,
    fields: Array,
    text: {
      type: String,
      default: 'type="event" | fields subtype level user action logdesc'
    },
    stores: Array,
    subFilter: {
      type: String
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    preview_slices_add: {
      type: [Object]
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      resizeSensor: null,
      clientHeight: null,
      tableItems: [],
      tableHeaders: [],
      selectedHeaders: [],
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 50],
      sortBy: '@timestamp',
      sortDesc: true,
      sub: '',
      exportxls: [],
      title: [],
      csv: csv,
      xls: xls
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    const vm = this
    this.gridItem = this.$parent
    this.resizeSensor = new ResizeSensor(this.$el, () => {
      const widgetHeight = this.$el.clientHeight
      if (widgetHeight !== vm.widgetHeight) {
        const newH = Math.ceil((widgetHeight + vm.gridItem.margin[1]) / (vm.gridItem.rowHeight + vm.gridItem.margin[1]))
        vm.widgetHeight = widgetHeight
        vm.gridItem.eventBus.$emit(
          'resizeEvent',
          'resized',
          vm.gridItem.i,
          vm.gridItem.x,
          vm.gridItem.y,
          newH,
          vm.gridItem.w
        )
      }
    })
    this.widgetHeight = this.$el.clientHeight
    this.tableHeaders = this.fields
    await this.initTable()
    await this.beforeload()
  },
  methods: {
    // handleDownload () {},
    async initTable () {
      this.disposeTable()
      if (this.preview_slices_add !== undefined) {
        this.perPage = 5
      }
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      try {
        let response = await axios.post(apiUrl + '/api/query/search', {
          start: this.startTime,
          end: this.endTime,
          instance: this.user_inst,
          index: this.user_index,
          stores: this.stores,
          sub: this.sub,
          text: this.text,
          bodySize: 150
        })
        for (let data of response.data) {
          // console.log(new Date(data._source['@timestamp']).getDate())
           const dateTime = new Date(data._source['@timestamp'])
          const formatDatetime = `${dateTime.getDate()}/${dateTime.getMonth() + 1}/${dateTime.getFullYear()}  ${dateTime.getHours()}:${dateTime.getMinutes()}:${dateTime.getSeconds()}`
          data._source['@timestamp'] = formatDatetime.toString()
          data._source['_raw'] = JSON.stringify(data._source['_raw']).replace(/"/g, '').replace(/\\/g, '')
          this.tableItems.push(data._source)
        }
        let options = JSON.parse(JSON.stringify(this.options))
        options.unshift({ 'text': 'Timestamp', 'value': '@timestamp' })
        options.push({ 'text': 'Raw Data', 'value': '_raw' })
        this.title = Object.values(options.map(header => (
          header.text
        )))
        this.title = this.title.toString()
        this.exportxls = this.tableItems.slice(0, 1500).map(item => (
          options.map(header => (
              item[header.value]
            )
          )))
      } catch (error) {
        console.error(error)
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-table')
    },
    disposeTable () {
      this.tableItems = []
    },
    duplicateChart () {
      this.$emit('duplicateChart', this.slice)
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.disposeTable()
        this.initTable()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.disposeTable()
        this.initTable()
      }
    },
    stores: {
      handler: function (stores) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.disposeTable()
        this.initTable()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.disposeTable()
        this.initTable()
      }
    },
    selectedHeaders: function (selectedHeaders) {
      if (selectedHeaders.length) {
        let headers = selectedHeaders.map(header => ({ key: header, sortable: true }))
        headers.unshift({ key: '@timestamp', sortable: true })
        headers.push({ key: 'rawData', sortable: false })
        this.tableHeaders = headers
      } else {
        this.tableHeaders = this.fields
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.disposeTable()
          this.initTable()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.disposeTable()
        this.initTable()
      }
    }
  }
}
</script>

<style scoped>
.center {
  float: none;
  margin: 0 auto;
  padding-top: 20%
}
.text-sm-left {
  color: #ccc;
  font-family: 'Helvetica';
  font-weight: 600;
  font-size: 1.4rem;
}
/* Avenir, Helvetica, Arial, sans-serif */
</style>



// WEBPACK FOOTER //
// src/components/x-table.vue